// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__T5u-f","subtitle":"Heading_subtitle__3r9IX","page_title":"Heading_page_title__rwvUX"};